document.addEventListener('DOMContentLoaded', () => {
    const siteDropdownContainer = document.querySelector('.menu .sites-dropdown-container');
    const siteDropdownMenu = document.querySelector('.menu .sites-dropdown-menu');

    if (siteDropdownContainer && siteDropdownMenu) {
        siteDropdownContainer.addEventListener('mouseover', () => {
            siteDropdownMenu.classList.add('show');
        });

        siteDropdownContainer.addEventListener('mouseleave', () => {
            siteDropdownMenu.classList.remove('show');
        });
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const parentSiteLanguage = document.querySelector('.wpml-ls-current-language');
    const siteLanguageMenu = document.querySelector('.wpml-ls-current-language > .sub-menu')

    if (parentSiteLanguage && siteLanguageMenu) {
        parentSiteLanguage.addEventListener('mouseover', () => {
            siteLanguageMenu.classList.add('show')
        })

        parentSiteLanguage.addEventListener('mouseleave', () => {
            siteLanguageMenu.classList.remove('show')
        })
    }
});

document.addEventListener('DOMContentLoaded', () => {
    let parentMenuItems = document.querySelectorAll('#menu-secondary-links .menu-item');

    if (parentMenuItems.length === 0) {
      parentMenuItems = document.querySelectorAll("#menu-secondary-menu .menu-item, #menu-secondary-menu-de .menu-item");
    }

    if (parentMenuItems) {
        parentMenuItems.forEach((parentMenuItem) => {
            const childPageContainer = parentMenuItem.querySelector('.sub-menu-container');

            if (childPageContainer) {
                parentMenuItem.addEventListener('mouseover', () => {
                    childPageContainer.classList.add('show');
                    parentMenuItem.querySelector('a').classList.add('active')
                });

                parentMenuItem.addEventListener('mouseleave', () => {
                    childPageContainer.classList.toggle('show');
                    parentMenuItem.querySelector('a').classList.remove('active')
                });
            }
        })
    }
})
